import { MutationTree } from 'vuex';
import {
  SET_DASHBOARD_DATA, SET_FAVORITES,
  SET_NONPROFIT_NOT_INTERESTING,
  HIDE_WELCOME_CARD,
  SET_MEMBER_LOCATIONS,
  SET_MEMBER_CURRENT_LOCATION,
  COMPLETE_TASK,
  SET_PROFILE_COMPLETION,
  SET_RECOMENDED_NONPROFIT_TO_FAVORITE,
  SET_COUNT_MEMBER_OPPORTUNITY,

} from './mutation-types';
import State from './state';
import { IDashboard } from '../../../models/interfaces/dashboard/iDashboard'
import { GeneralInfoOfMember } from '../../../models/classes/generalInfoOfMember'
import { INonprofit } from "../../../models/interfaces/dashboard/iNonprofit";
import { ILocation } from "../../../models/interfaces/iLocation";
import { IFan } from "../../../models/interfaces/iFan";
import { ITaskCard } from "../../../models/interfaces/dashboard/iTaskCard";

const mutations: MutationTree<State> = {
  [SET_DASHBOARD_DATA](state: State, data: IDashboard): void {
    const dashboardData: any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined)
        _acc[key] = data[key];

      return _acc;
    }, {})

    state.profile = dashboardData;
    },
    [SET_FAVORITES](state: State, data: INonprofit): void {
        if (!state.profile.member.fandomNonprofits) {
            state.profile.member.fandomNonprofits = [];
        }

        let fandomNonprofits: INonprofit[] = state.profile.member.fandomNonprofits;
        let nonprofitContain: boolean = fandomNonprofits.some(function (nonprofit: INonprofit) {
            return nonprofit.key === data.key;
        });
        if (nonprofitContain) {
            let index = state.profile.member.fandomNonprofits.findIndex(d => d.key === data.key);
            state.profile.member.fandomNonprofits.splice(index, 1);
        } else {
            state.profile.member.fandomNonprofits.push(data);
        }
    },
    [SET_NONPROFIT_NOT_INTERESTING](state: State, data: string): void {
        if (data) {
            let index = state.profile.recommended.findIndex(d => d.key === data);
            state.profile.recommended.splice(index, 1);
        }
    },

    [HIDE_WELCOME_CARD](state: State): void {
      state.profile.showWelcomeCard = false;
    },

    [SET_MEMBER_LOCATIONS](state: State, data: ILocation[]): void {
      state.profile.member.locations = data;
    },

    [SET_MEMBER_CURRENT_LOCATION](state: State, key: string): void {
      const locations = state.profile.member.locations;

      locations.forEach((el: ILocation) => {
        el.isCurrent = el.cityKey === key;
      });
    },

        [COMPLETE_TASK](state: State, task: ITaskCard): void {
            // debugger;
            state.profile.member.profileCompletion.remaining = [];

            if (task)
                state.profile.member.profileCompletion.remaining.push(task);
     },

        [SET_PROFILE_COMPLETION](state: State, type: string): void {
            let actionNotComplite: boolean = state.profile.member.profileCompletion.remainingFullList.
                some(function (taskCard: ITaskCard, index: number) {
                    if (taskCard.type == type) {
                        state.profile.member.profileCompletion.remainingFullList.splice(index, 1);
                        return true;
                    }               
                });

            if (actionNotComplite) {
                state.profile.member.profileCompletion.completedTasksCnt++;
                state.profile.member.profileCompletion.progress += 10;
            }
    },

    [SET_RECOMENDED_NONPROFIT_TO_FAVORITE](state: State, data: IFan): void {
      const index = state.profile.recommended.findIndex((elemet: INonprofit) => elemet.key === data.orgKey);

      if (index > -1) {
        state.profile.recommended[index].isFan = !!data.isFan;
      }
    },
    [SET_COUNT_MEMBER_OPPORTUNITY](state: State, data: number): void {
      state.profile.countMember = data;
    },
};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/dashboard/mutations.ts